import { useEffect, useState } from "react";
import { SelectInput } from "../SelectInput";
import { changeCorporationLanguage } from "../../api/tools";
import { Alert, AlertTypes } from "../Alert";
import { Button, ButtonTypes } from "../Button";
import { getAllCorporations } from "../../helpers/corporation";
import ReactFlagsSelect from 'react-flags-select';

export default function ChangeCorporationDefaultLanguage() {
    const [corporationId, setCorporationId] = useState(0);
    const [allCorporations, setAllCorporations] = useState([]);
    const [countryCode, setCountryCode] = useState('DK');
    const [languageKey, setLanguageKey] = useState('da');
    const [errorResponse, setErrorResponse] = useState('');
    const [successReponse, setSuccessResponse] = useState('');

    useEffect(() => {
        getAllCorporations().then(corporations => {
            if (corporations) {
                setAllCorporations(corporations as any);
            }
        })
    }, [])

    async function submit(e: Event) {
        e.preventDefault();
        resetState();
        const response = await changeCorporationLanguage({ corporationId, language: languageKey });
        if (response?.exception) {
            setErrorResponse(response?.message);
        } else {
            setSuccessResponse(response?.message);
        }
    }

    function resetState() {
        setErrorResponse('');
        setSuccessResponse('');
    }

     const handleLanguageSelect = (countryCode: string) => {
        setCountryCode(countryCode);
        switch (countryCode) {
            case 'DK':
                setLanguageKey('da');
                break;
            case 'SE':
                setLanguageKey('sv');
                break;
            case 'ES':
                setLanguageKey('es');
                break;
            case 'PT':
                setLanguageKey('pt');
                break;
            case 'GB':
                setLanguageKey('en');
                break;
            default:
                setLanguageKey('da');
                break;
        }
    }

    function isFormValid() {
        return  corporationId && languageKey;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4 full-width">
                        <h5 className="card-header">Set default corporation language</h5>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <SelectInput
                                        label="Corporation"
                                        options={
                                            allCorporations
                                        }
                                        placeholder={
                                            {
                                                value: '',
                                                label: 'Select corporation'
                                            }
                                        }
                                        value={corporationId}
                                        onValue={(option: any) => setCorporationId(option.value)}
                                    />
                                </div>
                                <div className='mb-4 col-md-4'>
                                    {
                                        corporationId > 0 ? (
                                            <>
                                                <label htmlFor="defaultFormControlSelect" className="form-label">Localized language</label>
                                                <ReactFlagsSelect
                                                    countries={["GB", "DK", "PT", "ES", "SE"]}
                                                    customLabels={{GB: "English", DK: "Danish", SE: "Swedish", ES: "Spanish", PT: "Portuguese",}}
                                                    onSelect={(code: string) => handleLanguageSelect(code)}
                                                    selected={countryCode}
                                                    selectButtonClassName="flags-select"
                                                />
                                            </>
                                        ) : null
                                    }
                                </div>
                            </div>
                            <div className="pt-4">
                                <Button type={ButtonTypes.PRIMARY} text="Set corporation language" className={!isFormValid() ? 'disabled' : ''} onPress={(e: Event) => submit(e)} />
                            </div>
                            {errorResponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.DANGER} text={errorResponse} />
                                </div>
                            )}
                            {successReponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.SUCCESS} text={successReponse} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}